import React from 'react';
import { useSelector } from 'react-redux';
import getObjectFromString from '../../functions/getObjectFromString';

const Checkbox = ({ id, dataColumn, updateData }) => {
    const dataState = useSelector((state) => getObjectFromString(state, dataColumn?.state));
    const initialDataFiltered = dataState?.data.find(element => element.id === id) //filter the data with the user required

    const handleChange = (e) => {
        e.preventDefault();
        updateData(
            {
                [dataColumn.value]: e.target.checked
            },
            initialDataFiltered
        )
    }

    return (
        <input
            type="checkbox"
            checked={initialDataFiltered[dataColumn.value]}
            onChange={handleChange}
            className="checkboxTableInput"
            style={{ cursor: "pointer" }}
        />
    )
}

export default Checkbox;